import { makeStyles } from '@mui/styles';
import cn from 'classnames';
import ForbiddenTooltip from '../../general/ForbiddenTooltip/ForbiddenTooltip';
import { History } from 'history';
import React, { MouseEventHandler } from 'react';
import { FormattedMessage } from 'intl';
import { SystemTranslationKeys } from 'intl/keys';

import { useProjectId } from 'store/project';
import { Link, useLocation } from 'react-router-dom';
import { PermissionTranslationKeys } from 'shared/domain/permissions/translationKeys';
import { useIsOffline } from '../../common/withIsOffline';

const useStyles = makeStyles({
  wrapper: { position: 'absolute' as const, bottom: 65 },
  link: {
    cursor: 'pointer',
    fontSize: '0.875rem',
    textDecoration: 'none',
    color: 'rgba(0,0,0,.54)',
    '&:hover:not(.disabled)': { color: 'rgba(0,0,0,.92)' },
    '&.disabled': { pointerEvents: 'none' },
  },
});

const getBaseUrl = (location): string => {
  return location.pathname.split('/').slice(0, 7).join('/');
};

const GDPRClauseLink = (): JSX.Element => {
  const projectId = useProjectId();
  const classes = useStyles();
  const location = useLocation();

  const isOffline = useIsOffline();

  const handleRouteChange: MouseEventHandler<HTMLAnchorElement> = (
    ev
  ): void => {
    if (getBaseUrl(location) === `/project/${projectId}/gdpr/clause`) {
      ev.preventDefault();
    }
  };

  return (
    <div className={classes.wrapper}>
      <ForbiddenTooltip
        visibleWhen={isOffline}
        reason={PermissionTranslationKeys.OFFLINE_UNAVAILABLE}
      >
        <Link
          to={`/project/${projectId}/gdpr/clause`}
          data-qa='gdpr_clause_link'
          className={cn(classes.link, { disabled: isOffline })}
          onClick={handleRouteChange}
        >
          <FormattedMessage id={SystemTranslationKeys.gdprClauseLinkText} />
        </Link>
      </ForbiddenTooltip>
    </div>
  );
};

export default GDPRClauseLink;
